import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets: string[] = [
    'submitButton',
    'allCompanies',
    'companySelect',
    'companySelectionContainer',
    'updateEntriesWithTextProperties',
    'warningBanner',
    'dangerBanner',
    'companyText',
  ]
  static values: {
    companyCount: NumberConstructor
    firmName: StringConstructor
  } = {
    companyCount: Number,
    firmName: String,
  }

  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly allCompaniesTarget: HTMLInputElement
  declare readonly companySelectTarget: HTMLSelectElement
  declare readonly companySelectionContainerTarget: HTMLElement
  declare readonly updateEntriesWithTextPropertiesTarget: HTMLInputElement
  declare readonly warningBannerTarget: HTMLElement
  declare readonly dangerBannerTarget: HTMLElement
  declare readonly companyTextTargets: HTMLElement[]
  declare readonly companyCountValue: number
  declare readonly firmNameValue: string

  private handleSelect2Event = (): void => {
    this.updateSelectedCompaniesText()
    this.updateSubmitButtonState()
    this.updateWarningBanner()
  }

  connect(): void {
    this.toggleCompanySelection()
    this.updateWarningBanner()

    $(this.companySelectTarget)
      .on('select2:select', this.handleSelect2Event)
      .on('select2:unselect', this.handleSelect2Event)
  }

  disconnect(): void {
    $(this.companySelectTarget)
      .off('select2:select', this.handleSelect2Event)
      .off('select2:unselect', this.handleSelect2Event)
  }

  toggleCompanySelection(): void {
    const allChecked = this.allCompaniesTarget?.checked

    if (allChecked) {
      this.companySelectTarget.disabled = true
      $(this.companySelectTarget)
        .prop('disabled', true)
        .trigger('change.select2')
    } else {
      this.companySelectTarget.disabled = false
      $(this.companySelectTarget)
        .prop('disabled', false)
        .trigger('change.select2')
    }

    this.updateSelectedCompaniesText()
    this.updateSubmitButtonState()
    this.updateWarningBanner()
  }

  toggleTextPropertiesWarning(): void {
    this.updateWarningBanner()
  }

  updateSelectedCompaniesText(): void {
    const allChecked = this.allCompaniesTarget?.checked
    const selectedCount = this.companySelectTarget?.selectedOptions.length ?? 0

    let buttonText: string
    let companyText: string

    if (allChecked) {
      buttonText = 'Push selected account detail templates to all companies'
      companyText = `all ${this.companyCountValue} companies of ${this.firmNameValue}`
    } else if (selectedCount > 0) {
      buttonText = `Push selected account detail templates to ${selectedCount} selected companies`
      companyText = `all ${selectedCount} selected companies of ${this.firmNameValue}`
    } else {
      buttonText = 'Push selected account detail templates to companies'
      companyText = `no companies of ${this.firmNameValue}`
    }

    const label = this.submitButtonTarget.querySelector('.sf-button__label')
    if (label) label.textContent = buttonText

    this.companyTextTargets.forEach((target) => {
      target.textContent = companyText
    })
  }

  updateSubmitButtonState(): void {
    const allChecked = this.allCompaniesTarget?.checked
    const selectedCount = this.companySelectTarget?.selectedOptions.length ?? 0

    const shouldEnable = allChecked || selectedCount > 0

    this.submitButtonTarget.disabled = !shouldEnable
  }

  updateWarningBanner(): void {
    const allChecked = this.allCompaniesTarget?.checked
    const selectedCount = this.companySelectTarget?.selectedOptions.length ?? 0
    const shouldShowBanner = allChecked || selectedCount > 0
    const hasTextProperties =
      this.updateEntriesWithTextPropertiesTarget?.checked

    if (shouldShowBanner) {
      if (hasTextProperties) {
        this.dangerBannerTarget.style.display = 'block'
        this.warningBannerTarget.style.display = 'none'
      } else {
        this.warningBannerTarget.style.display = 'block'
        this.dangerBannerTarget.style.display = 'none'
      }
    } else {
      this.warningBannerTarget.style.display = 'none'
      this.dangerBannerTarget.style.display = 'none'
    }
  }
}
